import { Directive, ElementRef, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: 'a[appExternalUrl]'
})
export class ExternalUrlDirective {

  constructor(private el: ElementRef, private router: Router) {
  }

  @HostListener('click', ['$event'])
  public clicked(event: Event) {
    const url = this.el.nativeElement.href;
    if (!url) {
      return;
    }
    this.router.navigate(['/external-redirect', { externalUrl: url }], {
      skipLocationChange: true,
    });
    event.preventDefault();
  }
}
